import { render, staticRenderFns } from "./tg_info.vue?vue&type=template&id=3524f37b&scoped=true&"
import script from "./tg_info.vue?vue&type=script&lang=js&"
export * from "./tg_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524f37b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3524f37b')) {
      api.createRecord('3524f37b', component.options)
    } else {
      api.reload('3524f37b', component.options)
    }
    module.hot.accept("./tg_info.vue?vue&type=template&id=3524f37b&scoped=true&", function () {
      api.rerender('3524f37b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/roles/row/tabs/tg/tg_info.vue"
export default component.exports